import datastore from "../store/hoa-datastore";

export default function useFieldDisabled() {
	const isHoaFieldDisabled = (key: string) => {
		return datastore.changedKeys.includes(key);
	};

	const isProceduresFieldDisabled = (key: string) => {
		return datastore.changedKeys.includes(`procedures-${key}`);
	};

	const isPropertyManagerDisabled = () => {
		// If any of the field is changed then disabled property management company checkbox
		return (
			isHoaFieldDisabled("propertyManager-propertyManagerName") ||
			isHoaFieldDisabled("propertyManager-propertyManagementCompanyAvailable") ||
			isHoaFieldDisabled("propertyManager-propertyManagerCompanyAddress") ||
			isHoaFieldDisabled("propertyManager-propertyManagerPhone") ||
			isHoaFieldDisabled("propertyManager-propertyManagerEmail")
		);
	};

	const isPropertyManagerFieldDisabled = (key: string) => {
		return isHoaFieldDisabled(`propertyManager-${key}`);
	};

	const isViolationRegulationFieldDisabled = (key: string) => {
		return isHoaFieldDisabled(`violationRegulations-${key}`);
	};

	const isGrassTypeRegulationDisabled = () => {
		return (
			isHoaFieldDisabled(`violationRegulations-landscaping-grassTypeRegulations`) ||
			isHoaFieldDisabled(`violationRegulations-landscaping-allowedTypesOfGrass`) ||
			isHoaFieldDisabled(`violationRegulations-landscaping-restrictedTypesOfGrass`)
		);
	};

	const isLandscapingFiledDisabled = (key: string, parentKey?: string) => {
		return isHoaFieldDisabled(`violationRegulations-landscaping-${key}`);
	};

	const isTrashFiledDisabled = (key: string, parentKey?: string) => {
		return isHoaFieldDisabled(`violationRegulations-trash-${key}`);
	};

	const isParkingFiledDisabled = (key: string, parentKey?: string) => {
		return isHoaFieldDisabled(`violationRegulations-parking-${key}`);
	};

	const isNuisanceFiledDisabled = (key: string, parentKey?: string) => {
		return isHoaFieldDisabled(`violationRegulations-nuisance-${key}`);
	};

	const isStructureFiledDisabled = (key: string, parentKey?: string) => {
		return isHoaFieldDisabled(`violationRegulations-structure-${key}`);
	};

	const isDocumentDisabled = (title: string) => {
		if (
			isHoaFieldDisabled(`documents-${title}-files`) ||
			isHoaFieldDisabled(`documents-${title}-hyperLink`) ||
			isHoaFieldDisabled(`documents-${title}-amendmentDate`)
		) {
			return true;
		}
		return false;
	};

	const isTimeOfPlacingGarbageCansDisabled = () => {
		if (
			isTrashFiledDisabled('placingTime') ||
			isTrashFiledDisabled('fromTimeSelection') ||
			isTrashFiledDisabled('fromDaySelection') ||
			isTrashFiledDisabled('fromHour') ||
			isTrashFiledDisabled('toTimeSelection') ||
			isTrashFiledDisabled('toDaySelection') ||
			isTrashFiledDisabled('toHour') ||
			isTrashFiledDisabled('hour')
		){
			return true;
		}
		return false;
	}

	return {
		isHoaFieldDisabled,
		isPropertyManagerDisabled,
		isPropertyManagerFieldDisabled,
		isProceduresFieldDisabled,
		isViolationRegulationFieldDisabled,
		isGrassTypeRegulationDisabled,
		isLandscapingFiledDisabled,
		isTrashFiledDisabled,
		isParkingFiledDisabled,
		isNuisanceFiledDisabled,
		isStructureFiledDisabled,
		isDocumentDisabled,
		isTimeOfPlacingGarbageCansDisabled
	};
}
